import { Field, Form as FormFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FiHome, FiLock, FiMail, FiUserCheck } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { createColab, getColabs } from 'redux/colabsSlice';
import { userCreateSchema } from '../validations/userCreateSchema';
import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';
import Select from 'react-select';
import classNames from 'classnames';

export const UserCreateForm = ({ branchOffices, roles, setModalShow }) => {
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);

  const handleSubmit = async values => {
    if (loadingButton) {
      return null;
    } else {
      setLoadingButton(true);
      let branchOfficesMap;

      if (values.sucursal === 'all') {
        branchOfficesMap = branchOffices.map(branch => ({
          branchOfficeId: branch.id,
          roleId: Number(values.rol),
          active: true
        }));
      } else {
        branchOfficesMap = [
          {
            branchOfficeId: Number(values.sucursal),
            roleId: Number(values.rol),
            active: true
          }
        ];
      }

      let userData = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        dni: values.dni,
        branchOffices: branchOfficesMap
      };

      const response = await dispatch(createColab(userData));
      if (response?.status < 400) {
        setModalShow && setModalShow(false);
        dispatch(getColabs());
      }
    }
    setLoadingButton(false);
  };

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        email: '',
        dni: '',
        phoneNumber: '',
        sucursal: '',
        rol: ''
      }}
      validationSchema={userCreateSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, setFieldTouched, setFieldValue }) => (
        <FormFormik>
          <Row className="g-3">
            <Col as={Form.Group} xs={12} sm={12}>
              <Form.Label>
                <FiUserCheck /> Nombre
              </Form.Label>
              <Form.Control
                as={Field}
                name="firstName"
                type="text"
                placeholder="Ingresa tu nombre"
                isInvalid={errors.firstName && touched.firstName}
              />

              {errors.firstName && touched.firstName ? (
                <p className="text-danger small m-0">{errors.firstName}</p>
              ) : null}
            </Col>

            <Col as={Form.Group} xs={12} sm={12}>
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                as={Field}
                name="lastName"
                type="text"
                placeholder="Ingresa tu apellido"
                isInvalid={errors.lastName && touched.lastName}
              />

              {errors.lastName && touched.lastName ? (
                <p className="text-danger small m-0">{errors.lastName}</p>
              ) : null}
            </Col>

            <Col as={Form.Group} xs={12} sm={6} md={6}>
              <Form.Label>DNI</Form.Label>
              <Form.Control
                as={Field}
                name="dni"
                type="number"
                placeholder="Ingresa tu DNI"
                isInvalid={errors.dni && touched.dni}
              />

              {errors.dni && touched.dni ? (
                <p className="text-danger small m-0">{errors.dni}</p>
              ) : null}
            </Col>

            <Col as={Form.Group} xs={12} sm={6} md={6}>
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                as={Field}
                name="phoneNumber"
                type="number"
                placeholder="Ingresa tu teléfono"
                isInvalid={errors.phoneNumber && touched.phoneNumber}
              />

              {errors.phoneNumber && touched.phoneNumber ? (
                <p className="text-danger small m-0">{errors.phoneNumber}</p>
              ) : null}
            </Col>

            <Col as={Form.Group} xs={12} sm={12}>
              <Form.Label>
                <FiMail /> Email <small>(1)</small>
              </Form.Label>
              <Form.Control
                as={Field}
                name="email"
                type="email"
                placeholder="Ingresa tu email"
                isInvalid={errors.email && touched.email}
              />

              {errors.email && touched.email ? (
                <p className="text-danger small m-0">{errors.email}</p>
              ) : null}
            </Col>

            <Col as={Form.Group} xs={12} sm={12}>
              <Form.Label>
                <FiHome /> Sucursal
              </Form.Label>
              <Select
                className={classNames({
                  'is-invalid': errors.sucursal && touched.sucursal
                })}
                name="sucursal"
                options={[
                  { value: '', label: '-- Seleccionar Sucursal --' },
                  ...branchOffices.map(sucursal => ({
                    value: sucursal.id,
                    label: sucursal.branch_office_name
                  })),
                  { value: 'all', label: 'Todas las sucursales' }
                ]}
                onChange={option => setFieldValue('sucursal', option.value)}
                onBlur={() => setFieldTouched('sucursal')}
                placeholder="-- Seleccionar Sucursal --"
              />
              {errors.sucursal && touched.sucursal ? (
                <p className="text-danger small m-0">{errors.sucursal}</p>
              ) : null}
            </Col>

            <Col as={Form.Group} xs={12} sm={12}>
              <Form.Label>
                <FiLock /> Rol <small>(2)</small>
              </Form.Label>
              <Select
                className={classNames({
                  'is-invalid': errors.rol && touched.rol
                })}
                name="rol"
                options={[
                  { value: '0', label: '-- Seleccionar Rol --' },
                  ...roles.map(rol => ({ value: rol.id, label: rol.name }))
                ]}
                onChange={option => setFieldValue('rol', option.value)}
                onBlur={() => setFieldTouched('rol')}
                placeholder="-- Seleccionar Rol --"
              />
              {errors.rol && touched.rol ? (
                <p className="text-danger small m-0">{errors.rol}</p>
              ) : null}
            </Col>

            <Col xs={12} sm={12}>
              <Form.Text className="text-muted">
                <small>(1)</small> Te enviaremos un mail, por favor revisalo.{' '}
                <br />
                <small>(2)</small> Puede modificar los permisos luego.
              </Form.Text>
            </Col>

            <Col xs={12} sm={12}>
              {!loadingButton ? (
                <Button
                  variant="success"
                  type="submit"
                  className="w-100"
                  disabled={
                    !!errors.firstName ||
                    !!errors.lastName ||
                    !!errors.email ||
                    !!errors.dni ||
                    !!errors.phoneNumber ||
                    !!errors.sucursal ||
                    !!errors.rol ||
                    loadingButton
                  }
                >
                  Registrar Usuario
                </Button>
              ) : (
                <MyButtonSpinner className="w-100" />
              )}
            </Col>
          </Row>
        </FormFormik>
      )}
    </Formik>
  );
};
UserCreateForm.propTypes = {
  roles: PropTypes.array.isRequired,
  branchOffices: PropTypes.array.isRequired,
  setModalShow: PropTypes.func
};
